// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IChangeStatusRequestSchema {
  /** Комментарий **/
  comment: string;
  /** ID записи **/
  id: number;
  /** Статус **/
  status: EStatus;
}

export enum EStatus {
  /** Свободно **/
  'Available' = 'available',
  /** Занято **/
  'Busy' = 'busy',
  /** Не актуальна **/
  'Canceled' = 'canceled',
  /** Уточняется заселение **/
  'Confirming' = 'confirming',
  /** Отклонено **/
  'Declined' = 'declined',
  /** На модерации **/
  'Moderation' = 'moderation',
  /** Новая **/
  'New' = 'new',
  /** Не дозвонились **/
  'Phone_not_available' = 'phone_not_available',
}
